import {
  AiModelState,
  getPrefixName,
  hideRadioClassName,
  Prefix,
  stores2storeScopes,
} from './share';
import { Radio } from 'antd';
import { useCallback, useMemo } from 'react';
import { updatePickUp } from 'views/BootGuide/service';
import ModalMode from './ModalMode';
import { useTranslate } from '@tolgee/react';
import useSmartField from 'hooks/useSmartField';

type FV = BootGuide.AiModel.FormValues.PickUp;

export function useLabel() {
  const { t } = useTranslate();

  return useMemo(() => {
    return {
      noSupport: t('本店不支持上门自提'),
      support: t('本店支持上门自提'),
    } as const;
  }, [t]);
}

function PickUp({ prefix, singleMode }: { prefix?: Prefix; singleMode?: boolean }) {
  const label = useLabel();

  const {
    field: { value, onChange },
  } = useSmartField<FV['value']>(getPrefixName('value', prefix));

  const getHideStyle = (type: FV['value']) =>
    singleMode && value !== type ? { display: 'none' } : undefined;

  return (
    <div className="mt-[6px]">
      {Object.keys(label).map((key) => {
        return (
          <div key={key} className="mb-2" style={getHideStyle(key)}>
            <Radio
              className={singleMode ? hideRadioClassName : undefined}
              checked={value === key}
              onChange={({ target: { checked } }) => checked && onChange(key)}
            >
              {label[key]}
            </Radio>
          </div>
        );
      })}
    </div>
  );
}

export function PickUpBootGuide(props: AiModelState<FV>) {
  const label = useLabel();

  return (
    <ModalMode
      state={props}
      title={props.t('上门自提')}
      tips={props.t('您的店铺是否支持上门自提?以下是一些常见的选项供您选择和调整')}
      completeMinute={1}
      form={<PickUp />}
      getFirstInitialValues={useCallback(({ stores }): { values: FV[] } => {
        return {
          values: [
            { value: 'noSupport', storeScopes: stores2storeScopes(stores) },
            { value: 'support', storeScopes: [] },
          ],
        };
      }, [])}
      updateApi={updatePickUp}
      getFirstFormItem={({ value }, _, storeSelect) => {
        return (
          <div>
            <section>
              {label[value]}
              {storeSelect}
            </section>
          </div>
        );
      }}
      getFirstFormStoreSelectKey={({ value }) => value}
    />
  );
}

export default PickUp;
